import { useMutation } from "react-query";
import { updateTexasGrouping } from "../../../../../actions/Utilities/TexasGrouping";

const useEditTexasGrouping = () => {
  return useMutation(updateTexasGrouping);
};

export default useEditTexasGrouping;
